import React, {useEffect, useState} from 'react'
import {Button, Fab, Grid, MenuItem, MenuList, Tooltip, useMediaQuery} from '@material-ui/core'

export default React.memo(props => {

  const matchesMd = useMediaQuery(theme => theme.breakpoints.down('md'))
  const matchesXs = useMediaQuery(theme => theme.breakpoints.down('xs'))

  const [buttons, setButtons] = useState([])

  const btns = {
    add: {
      title: 'Ajouter',
      className: 'EurestoSecondary--text',
      icon: 'ei-commun_ajouter',
    },
    update: {
      title: 'Modifier',
      className: 'EurestoSecondary--text',
      icon: 'ei-commun_dupliquer'
    },
    archive: {
      title: 'Archiver',
      className: 'EurestoError--text',
      icon: 'ei-commun_archiver'
    },
    duplicate: {
      title: 'Dupliquer',
      className: 'EurestoSecondary--text',
      icon: 'ei-commun_dupliquer'
    },
    delete: {
      title: 'Supprimer',
      className: 'EurestoError--text',
      icon: 'ei-commun_supprimer'
    },
    unarchive: {
      title: 'Désarchiver',
      className: 'EurestoSecondary--text',
      icon: 'ei-commun_reouvrir'
    },
  }

  useEffect(() => {
    const b = []
    if (props.isAllow && (props.action !== 'update' && props.action !== 'add')) {
      Object.keys(props.isAllow).filter(act => props.isAllow[act]).map(act => {
        if (props.btns && props.btns[act]) {
          b.push({
            ...props.btns[act],
            action: act
          })
        } else if (btns[act]) {
          b.push({
            ...btns[act],
            action: act
          })
        }
      })
    } else if (props.isAllow && ((props.isAllow.update && props.action === 'update')
      || (props.isAllow.add && props.action === 'add'))) {
      b.push({
        title: 'Annuler',
        className: 'EurestoError--text',
        icon: 'ei-commun_fermer',
        action: 'cancel',
      })
      b.push({
        title: 'Enregistrer',
        className: 'EurestoSecondary--text',
        icon: 'ei-commun_valider',
        action: 'save',
      })
    }

    if (props.buttons) {
      b.push(...props.buttons.filter(button => button.isAllow))
    }
    setButtons(b)
  }, [props.buttons, props.isAllow, props.action])

  return !matchesMd &&
    <Grid container spacing={0} justify={'flex-end'} alignContent={'center'} alignItems={'center'}>
      {
        buttons.map((button, i) => <Button key={button.title + '-' + i}
                                           size={'small'}
                                           variant={'contained'}
                                           style={{
                                             ...(i > 0 && { marginLeft: 5 } || {}),
                                             border: '1px solid ' + EurestoColor('EurestoPrimary'),
                                             ...(button.style || {}),
                                           }}
                                           onClick={(e) => {
                                             e.stopPropagation()
                                             props.onChange(button.action)
                                           }}
                                           disabled={button.disabled || false}
                                           className={(button.disabled ? 'EurestoDisabled' : 'EurestoText--text ' + (button.className && button.className.replace('--text', '') || 'EurestoPrimary'))}>
          <Grid container justify={'center'} alignContent={'center'} alignItems={'center'}>&nbsp;<i
            className={button.icon + ' ' + (button.disabled ? '' : 'EurestoText--text')}/>&nbsp;{button.title}&nbsp;
          </Grid></Button>
        )
      }
    </Grid>
    ||
    buttons && buttons.length > 0 && <Tooltip interactive disableTouchListener
                                                margin={'dense'} title={
      <MenuList style={{ padding: 0 }}>
        {
          buttons.map(button => <MenuItem color={'error'}
                                          className={(button.disabled ? 'EurestoDisabled' : 'EurestoText--text ' + (button.className && button.className.replace('--text', '') || 'EurestoPrimary'))}
                                          onClick={() => props.onChange(button.action)}><span
            className={'EurestoText--text'}><Grid container
                                                  justify={'center'}
                                                  alignContent={'center'}
                                                  alignItems={'center'}>&nbsp;
            <i
              className={button.icon + ' ' + (button.disabled ? '' : 'EurestoText--text')}/>&nbsp;{button.title}&nbsp;
          </Grid></span></MenuItem>)
        }
      </MenuList>
    }>
      <Fab style={{
        width: 25, height: 25,
        ...(matchesXs && !props.isSubComponent && { position: 'fixed', bottom: 5, right: 5 } || { padding: 5 })
      }}
           className={'EurestoPrimary'}>
        <i className={'ei-commun_configuration EurestoText--text'} style={{ fontSize: 16 }}/></Fab>
    </Tooltip>
  || <div/>

})


// WEBPACK FOOTER //
// ./app/Components/EurestoAction.js